import { render, staticRenderFns } from "./task_pass.vue?vue&type=template&id=b4b463dc&scoped=true"
import script from "./task_pass.vue?vue&type=script&lang=js"
export * from "./task_pass.vue?vue&type=script&lang=js"
import style0 from "./task_pass.vue?vue&type=style&index=0&id=b4b463dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b463dc",
  null
  
)

export default component.exports